const HOST = process.env.REACT_APP_API_BASE_URL;
const HOST1 = process.env.REACT_APP_SECONDARY_API_BASE_URL;
export const SERVICES = {
  GET_STATES: `${HOST}/api/masters/states`,
  GET_DIVISIONS: `${HOST}/api/masters/divisions`,
  GET_POSITIONS: `${HOST}/api/masters/positions`,
  GET_PROFESSIONS: `${HOST}/api/masters/professions`,
  GET_PAYABLE_CITIES: `${HOST1}/contribution/api/masters/payableCities`,
  GET_UIN_TYPES: `${HOST1}/contribution/api/masters/uinTypes`,
  GET_PAYMENT_METHODS: `${HOST1}/contribution/api/masters/paymentMethods`,
  GET_PAYMENT_GATEWAYS: `${HOST1}/contribution/api/masters/paymentGateways`,
};
